import { render, staticRenderFns } from "./DictionaryCategories.vue?vue&type=template&id=714bf922&"
import script from "./DictionaryCategories.vue?vue&type=script&lang=js&"
export * from "./DictionaryCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports